var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "refund-spu-list-widget" },
    [
      _vm.detail.role && _vm.detail.role.name
        ? _c("div", { staticClass: "store-info" }, [
            _vm._v(_vm._s(_vm.detail.role.name)),
          ])
        : _vm._e(),
      _vm._l(_vm.tableData, function (group, index) {
        return _c(
          "div",
          { key: index, staticClass: "promotion-group" },
          [
            _c("div", { staticClass: "left-promotion flex a-i-c" }, [
              group.promotion && group.promotion.title
                ? _c(
                    "div",
                    { staticClass: "promotion-tag flex-center t-c origin" },
                    [_vm._v("特價")]
                  )
                : group.orderItemList[0].type == 0
                ? _c(
                    "div",
                    { staticClass: "promotion-tag flex-center t-c blue" },
                    [_vm._v("普通商品")]
                  )
                : group.orderItemList[0].type == 1
                ? _c(
                    "div",
                    { staticClass: "promotion-tag flex-center t-c red" },
                    [_vm._v("包裹")]
                  )
                : _vm._e(),
              group.promotion && group.promotion.title
                ? _c("span", [
                    _vm._v(" " + _vm._s(group.promotion.title) + " "),
                  ])
                : _vm._e(),
            ]),
            _vm._l(group.orderItemList, function (item) {
              return _c("order-detail-spu-list-item", {
                key: item.id,
                attrs: { "item-data": item, detail: _vm.detail },
              })
            }),
            group.promotionPrice
              ? _c("div", { staticClass: "subtotal" }, [
                  _vm._v("小計：NT$ " + _vm._s(group.promotionPrice)),
                ])
              : _vm._e(),
            group.promotion && group.promotion.title
              ? _c("div", { staticClass: "diviser-line" })
              : _vm._e(),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }